/* eslint-disable react-hooks/rules-of-hooks */
import { useQuery } from '@apollo/client';
import ContentQuery from './ContentQuery';

const ContentConnectorApollo = ({ identifier, children }) => {
  const { loading, error, data } = useQuery(ContentQuery, {
    variables: { identifier },
  });

  const result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.content = { ...data.content };
  }

  return children(result);
};

export default ContentConnectorApollo;
